import SleepPatternsTableErrorNotification from './SleepPatternsTableErrorNotification'

export default SleepPatternsTableErrorNotification
